var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -4,
    y: -4,
    width: 36,
    height: 48
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_1395_9196_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 4,
    d: "M28 0V40H20C10.5719 40 5.85786 40 2.92893 37.0711C0 34.1421 0 29.4281 0 20C0 10.5719 0 5.85786 2.92893 2.92893C5.85786 0 10.5719 0 20 0H28Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19617 29.1666H18.8028C21.3328 29.1666 22.3412 27.6174 22.4603 25.7291L22.937 18.1574C23.0653 16.1774 21.4887 14.4999 19.4995 14.4999C18.9403 14.4999 18.427 14.1791 18.1703 13.6841L17.5103 12.3549C17.0887 11.5208 15.9887 10.8333 15.0537 10.8333H12.9545C12.0103 10.8333 10.9103 11.5208 10.4887 12.3549L9.82867 13.6841C9.572 14.1791 9.05867 14.4999 8.4995 14.4999C6.51034 14.4999 4.93367 16.1774 5.062 18.1574L5.53867 25.7291C5.64867 27.6174 6.66617 29.1666 9.19617 29.1666Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 16.3333H15.375",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9987 25.5001C15.6395 25.5001 16.9779 24.1617 16.9779 22.5209C16.9779 20.8801 15.6395 19.5417 13.9987 19.5417C12.3579 19.5417 11.0195 20.8801 11.0195 22.5209C11.0195 24.1617 12.3579 25.5001 13.9987 25.5001Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_1395_9196_clip_path",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0V40H20C10.5719 40 5.85786 40 2.92893 37.0711C0 34.1421 0 29.4281 0 20C0 10.5719 0 5.85786 2.92893 2.92893C5.85786 0 10.5719 0 20 0H28Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3995e84cab72ebedd2d6e2cd28fb74fb.svg";
export { ForwardRef as ReactComponent };